import type { ReactNode } from 'react';
import { cn } from '../lib/cn';
import { Icon, type IconName } from './icon';

export interface EmptyStateProps {
  icon?: IconName;
  /** What belongs here, e.g. "Noch keine Gruppen". */
  title: ReactNode;
  /** What the person can do about it. */
  description?: ReactNode;
  /** The one matching action. */
  action?: ReactNode;
  /** Less space around it, for tiles and side columns. */
  compact?: boolean;
  className?: string;
}

export function EmptyState({
  icon = 'inbox',
  title,
  description,
  action,
  compact = false,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center px-4 text-center',
        compact ? 'py-6' : 'py-10',
        className,
      )}
    >
      <div
        className={cn(
          'flex items-center justify-center rounded-md border border-line bg-sunken text-fg-subtle',
          compact ? 'mb-2 size-8' : 'mb-3 size-10',
        )}
      >
        <Icon name={icon} className={compact ? 'size-4' : 'size-5'} />
      </div>
      <p className={cn('font-medium text-fg', compact ? 'text-sm' : 'text-base')}>{title}</p>
      {description && <p className="mt-1 max-w-sm text-fg-muted">{description}</p>}
      {action && <div className={compact ? 'mt-3' : 'mt-4'}>{action}</div>}
    </div>
  );
}
